import { UserEffects } from './user.effect';
import { ProjectEffect } from '@app/core/store/effects/project.effect';
import { SiteEffect } from '@app/core/store/effects/site.effect';
import { SettingsEffect } from '@app/core/store/effects/settings.effect';
import { ResourceEffect } from '@app/core/store/effects/resource.effect';
import { CommentsEffect } from '@app/core/store/effects/comments.effect';
import { WorkOrderEffect } from '@app/core/store/effects/work-order.effect';
import { DashboardEffect } from '@app/core/store/effects/dashboard.effect';
import { DocumentsEffect } from './documents.effect';
import { WorkCenterEffect } from '@app/core/store/effects/work-center.effect';
import { PdfMarkupEffect } from './pdf-markup.effect';

export const effects = [
  UserEffects,
  ProjectEffect,
  SiteEffect,
  SettingsEffect,
  CommentsEffect,
  WorkOrderEffect,
  DashboardEffect,
  DocumentsEffect,
  WorkCenterEffect,
  PdfMarkupEffect,
];

export * from './user.effect';
export * from './project.effect';
export * from './site.effect';
export * from './resource.effect';
export * from './settings.effect';
export * from './comments.effect';
export * from './work-order.effect';
export * from './dashboard.effect';
export * from './documents.effect';
export * from './work-center.effect';
export * from './pdf-markup.effect';
